import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ZapIcon from '@zapsa/zap-icons';

import luxaviationLogo from 'assets/images/luxaviation_logo.svg';
import cdclLogo from 'assets/images/cdcl_logo.svg';
import myEnergyLogo from 'assets/images/myenergy_logo.svg';
import capLogo from 'assets/images/cap4_logo.png';
import prefaluxLogo from 'assets/images/prefalux_logo.png';
import lincLogo from 'assets/images/linc_logo.png';
import economyLogo from 'assets/images/ministere_logo.png';
import siliconLogo from 'assets/images/logo_silicon.png';

class TrustView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.autoNextSlide = ::this.autoNextSlide;
    this.getClients = ::this.getClients;
    this.state = {
      currentClients: 0,
    };

    this.autoNextSlide();
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  getClients() {
    return [
      { logo: luxaviationLogo, link: 'https://www.luxaviation.com/en/' },
      { logo: cdclLogo, link: 'https://www.cdclux.com/?lang=en' },
      {
        logo: myEnergyLogo,
        link:
          'https://www.myenergy.lu/fr/particuliers/conseil-energie?gclid=CjwKCAiAy-_iBRAaEiwAYhSlA8ChFGCIyg9rhQJu9RLKoepfcMrqoIiBV5JJg99EtCPBbvzrjOIqkBoCzI8QAvD_BwE',
      },
      {
        logo: capLogo,
        link:
          'https://www.myenergy.lu/fr/particuliers/conseil-energie?gclid=CjwKCAiAy-_iBRAaEiwAYhSlA8ChFGCIyg9rhQJu9RLKoepfcMrqoIiBV5JJg99EtCPBbvzrjOIqkBoCzI8QAvD_BwE',
      },
      {
        logo: lincLogo,
        link:
          'http://www.linc.lu/?lang=en',
      },
      {
        logo: prefaluxLogo,
        link:
          'http://www.prefalux.lu',
      },
      {
        logo: economyLogo,
        link:
          'https://meco.gouvernement.lu/fr.html',
      },
      {
        logo: siliconLogo,
        link:
          'https://www.siliconluxembourg.lu',
      },
    ];
  }

  autoNextSlide() {
    this.timeout = setTimeout(() => {
      this.setState(
        prevState => ({
          currentClients: prevState.currentClients + 3 > this.getClients().length ? 0 : prevState.currentClients + 3,
        }),
        () => {
          this.autoNextSlide();
        },
      );
    }, 5000);
  }

  render() {
    return (
      <div>
        <hr />
        <div className="container-title">{this.props.translations['trust.theyTrustUs']}</div>
        <div className="container">
          <div className="container-large u-flex u-flex-align-items--between clients-list">
            <ZapIcon
              icon="arrowLeft--solid"
              className="u-cursor"
              onClick={() => {
                clearTimeout(this.timeout);
                this.setState(
                  prevState => ({
                    currentClients:
                      prevState.currentClients - 3 < 0
                        ? this.getClients().length - (this.getClients().length % 3)
                        : prevState.currentClients - 3,
                  }),
                  () => {
                    this.autoNextSlide();
                  },
                );
              }}
            />
            {this.getClients()
              .slice(this.state.currentClients, this.state.currentClients + 3)
              .map(client => (
                <a target="_blank" rel="noopener noreferrer" href={client.link} className="client">
                  <img src={client.logo} alt="" />
                </a>
              ))}
            <ZapIcon
              icon="arrowRight--solid"
              className="u-cursor"
              onClick={() => {
                clearTimeout(this.timeout);
                this.setState(
                  prevState => ({
                    currentClients:
                      prevState.currentClients + 3 >= this.getClients().length ? 0 : prevState.currentClients + 3,
                  }),
                  () => {
                    this.autoNextSlide();
                  },
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default TrustView;
